import { WebGLRenderTarget, Object3D, InstancedMesh, Clock, MeshBasicMaterial } from "three"
import { BackfaceMaterial } from './BackfaceMaterial'
import { RefractionMaterial } from './RefractionMaterial'
import { loadGLTF } from '../../Reusable/loadGLTF'

export class Diamonds {
  constructor ({ renderer, onResize, onLoop, scene, camera, getScreen }) {
    this.renderer = renderer
    this.onResize = onResize
    this.onLoop = onLoop
    this.camera = camera
    this.getScreen = getScreen
    this.o3d = new Object3D()
    this.scene = scene

    let setup = () => {
      if (this.envFbo) {
        this.envFbo.dispose()
      }
      if (this.backfaceFbo) {
        this.backfaceFbo.dispose()
      }
      if (this.backfaceMaterial) {
        this.backfaceMaterial.dispose()
      }
      if (this.refractionMaterial) {
        this.refractionMaterial.dispose()
      }

      let domEl = this.renderer.domElement
      let rect = domEl.getBoundingClientRect()
      let dpi = 1.0
      this.envFbo = new WebGLRenderTarget(rect.width * dpi, rect.height * dpi)
      this.backfaceFbo = new WebGLRenderTarget(rect.width * dpi, rect.height * dpi)
      this.backfaceMaterial = new BackfaceMaterial()
      this.refractionMaterial = new RefractionMaterial({ envMap: this.envFbo.texture, backfaceMap: this.backfaceFbo.texture, resolution: [rect.width * dpi, rect.height * dpi] })
    }

    onResize(() => {
      setup()
    })

    this.clock = new Clock()

    this.dummy = new Object3D()

    this.onResize(() => {
      this.viewport = this.getScreen({ camera: this.camera, depth: this.camera.position.z })
    })

    this.diamonds = new Array(80).fill().map((_, i) => ({
      position: [i < 5 ? 0 : this.viewport.width / 2 - Math.random() * this.viewport.width, 40 - Math.random() * 40, i < 5 ? 26 : 10 - Math.random() * 20],
      factor: 0.1 + Math.random(),
      direction: Math.random() < 0.5 ? -1 : 1,
      rotation: [Math.sin(Math.random()) * Math.PI, Math.sin(Math.random()) * Math.PI, Math.cos(Math.random()) * Math.PI]
    }))

    // let shaderCube = new ShaderCube({ renderer: this.renderer, loop: this.onLoop, res: 64 })

    this.diamondURL = require('file-loader!./glb/diamond.glb')
    loadGLTF(this.diamondURL)
      .then((item) => {
        if (item && item.scene && item.scene.children && item.scene.children[0] && item.scene.children[0].geometry) {
          let geo = item.scene.children[0].geometry
          this.model = new InstancedMesh(geo, new MeshBasicMaterial({ color: 0xfababa }), this.diamonds.length)
          this.o3d.add(this.model)
        }
      })

    let looper = () => {
      if (!this.model || !this.model.geometry) {
        return
      }

      // Update instanced diamonds
      this.diamonds.forEach((data, i) => {
        const t = this.clock.getElapsedTime()
        data.position[1] -= (data.factor / 5) * data.direction
        if (data.direction === 1 ? data.position[1] < -50 : data.position[1] > 50)
          data.position = [i < 5 ? 0 : this.viewport.width / 2 - Math.random() * this.viewport.width, 50 * data.direction, data.position[2]]
        const { position, rotation, factor } = data
        this.dummy.position.set(position[0], position[1], position[2])
        this.dummy.rotation.set(rotation[0] + t * factor, rotation[1] + t * factor, rotation[2] + t * factor)
        this.dummy.scale.set(1 + factor, 1 + factor, 1 + factor)
        this.dummy.updateMatrix()
        this.model.setMatrixAt(i, this.dummy.matrix)
      })

      this.diamonds.visible = false
      this.model.instanceMatrix.needsUpdate = true
      this.renderer.setRenderTarget(this.envFbo)
      this.renderer.render(this.scene, this.camera)
      this.renderer.setRenderTarget(null)
      this.diamonds.visible = true

      this.diamonds.visible = false
      this.renderer.setRenderTarget(this.backfaceFbo)
      this.model.material = this.backfaceMaterial
      this.renderer.render(this.scene, this.camera)
      this.renderer.setRenderTarget(null)
      this.diamonds.visible = true

      this.model.material = this.refractionMaterial
      this.renderer.render(this.scene, this.camera)
    }

    this.onLoop(() => {
      looper()
    })
  }
}